var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full max-w-lg mx-auto p-4 sm:py-16"},[_c('RegisterForm',{on:{"user-registered":_vm.onUserRegistered}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }